import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import XrVrComponent from '../xrvr/XrVrComponent';

function XrVrView() {
  return (
    <MainLayout>
      <XrVrComponent />
    </MainLayout>
  );
}

export default XrVrView;
